export const delay = 250;
export default {
  delay
};
